import {format} from "date-fns";
import {enGB, hy, ru} from "date-fns/locale";

export const notificationText = (row, t) => t(row.message || "Notifications", {number: row.orderNumber || "", orderNumber: row.orderNumber || ""});
export function notificationDay(date, now = new Date()) {
    const value = new Date(date), today = new Date(now), yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    return value.toDateString() === today.toDateString() ? "NotificationToday"
        : value.toDateString() === yesterday.toDateString() ? "NotificationYesterday" : "NotificationEarlier";
}
export function notificationTime(date, language) {
    const value = new Date(date);
    if (Number.isNaN(value.getTime())) return "";
    const pattern = value.getFullYear() === new Date().getFullYear() ? "d MMM, HH:mm" : "d MMM yyyy, HH:mm";
    // Bundled locales also work in browsers whose Intl build omits Armenian date data.
    return format(value, pattern, {locale: language === "hy" ? hy : language === "ru" ? ru : enGB});
}

